import { SETTINGS_ACTION_TYPES } from '../actions/action_types';
import { FONT_SIZES } from '../../services/font_sizes';

export const initialState = {
  fontSize: FONT_SIZES.REGULAR,
  showSentenceNumbers: false,
  showReadForMe: false,
  showRevealWords: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SETTINGS_ACTION_TYPES.LOAD_USER_SETTINGS: {
      const { fontSize } = payload;
      return { ...state, ...payload, fontSize: fontSize || FONT_SIZES.REGULAR };
    }
    case SETTINGS_ACTION_TYPES.UPDATE_FONT_SIZE:
      return { ...state, fontSize: payload || FONT_SIZES.REGULAR };
    case SETTINGS_ACTION_TYPES.TOGGLE_SENTENCE_NUMBERING:
      return { ...state, showSentenceNumbers: payload };
    case SETTINGS_ACTION_TYPES.TOGGLE_READ_FOR_ME:
      return { ...state, showReadForMe: payload };
    case SETTINGS_ACTION_TYPES.TOGGLE_REVEAL_WORDS:
      return { ...state, showRevealWords: payload };
    default:
      return state;
  }
};
